import { render, staticRenderFns } from "./CustomerBatchUpload.vue?vue&type=template&id=446f960a"
import script from "./CustomerBatchUpload.vue?vue&type=script&lang=ts"
export * from "./CustomerBatchUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports